import React from 'react'
import ProssimoArrivo from '../../atoms/ProssimoArrivo/ProssimoArrivo'
import Loading from './../../atoms/Loading/Loading'
import useTrans from '../../../hooks/useTrans'

const ModalBlockLoading = () => {
  return (
    <div className="modal-loading">
      <Loading />
    </div>
  )
}

const ModalBlockActions = ({ children }) => {
  return <div className="modal-actions">{children}</div>
}

const ModalBlockProssimiArrivi = ({ articoli }) => {
  const t = useTrans()
  return articoli.filter((articolo) => articolo.prossimi_arrivi?.length > 0).length > 0 ? (
    <div className="modal-prossimi-arrivi">
      {articoli.map((articolo, i) => (
        <div className="modal-prossimi-arrivi__article" key={i}>
          {articolo.prossimi_arrivi.length === 1 && articoli.length === 1 ? (
            <>
              <span className="modal-prossimi-arrivi__article-title">{t('Prossimo arrivo')}: </span>{' '}
              <span className="modal-prossimi-arrivi__arrival">
                <ProssimoArrivo prossimo_arrivo={articolo.prossimi_arrivi[0]} />
              </span>
            </>
          ) : (
            <>
              <p className="modal-prossimi-arrivi__article-title">
                {articolo.prossimi_arrivi.length === 1 ? (
                  <>{t('Prossimo arrivo')} </>
                ) : (
                  <>{t('Prossimi arrivi')} </>
                )}
                {articoli.length > 1 && (
                  <span className="modal-prossimi-arrivi__article-code">{articolo.codice}</span>
                )}
              </p>
              <div className="modal-prossimi-arrivi__arrivals">
                {articolo.prossimi_arrivi
                  ? articolo.prossimi_arrivi.map((prossimo_arrivo, index) => (
                      <p className="modal-prossimi-arrivi__arrival" key={index}>
                        <ProssimoArrivo prossimo_arrivo={prossimo_arrivo} />
                      </p>
                    ))
                  : null}
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  ) : (
    <></>
  )
}

const ModalBlocks = () => <></>

ModalBlocks.Loading = ModalBlockLoading
ModalBlocks.ProssimiArrivi = ModalBlockProssimiArrivi
ModalBlocks.Actions = ModalBlockActions

export default ModalBlocks
